export const filterOptions = [
  { label: '12 months', value: '12' },
  { label: '3 months', value: '3' },
];
